const videoWithTextSections = document?.querySelectorAll(".video-with-text");

videoWithTextSections?.forEach((item) => {
  const video = item?.querySelector("video");
  const videoOverlay = item?.querySelector(".video-overlay");

  videoOverlay?.addEventListener("click", function () {
    videoOverlay.style.display = "none";
    if (video) {
      video.play();
    }
  });
});
